module.exports = __webpack_public_path__ + "static/media/ic_favorite_border.21fa313b.svg";